module.exports = __webpack_public_path__ + "DINNextLTPro-HeavyItalic.eot?71386a04ebd9822db28379fb8c027a25";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-HeavyItalic.eot
// module id = 314
// module chunks = 0